<template>
    <v-text-field
        class="query-field flex-grow-0"
        v-bind="$attrs"
        dense
        solo
        style="height: 36px"
        :height="20"
        flat
        background-color="white"
        append-icon="ic-20 ic-searchmagnifier ic-col-grey"
        clear-icon="ic-20 ic-x ic-col-grey"
        clearable
        hide-details
        :placeholder="$t('suchen')"
        v-on="$listeners"
    />
</template>

<script>
export default {
    name: 'QueryField',
};
</script>

<style lang="scss" scoped>
.query-field {
    background-color: white;
    padding: 3px 5px;
    ::v-deep {
        .v-input__control {
            min-height: 30px !important;
        }
    }
}
</style>
